import type { AppLocale } from '../messages';

/**
 * Строки участка «common». Свой файл у каждого участка, а не общий `messages.ts` на 4300 строк:
 * участки правятся параллельно, и общий файл давал бы конфликт на каждой новой строке.
 * Ключ добавляется во все четыре словаря — `en` задаёт набор, остальные проверяются типом.
 */
const en = {
  actionUndo: 'Undo',
  actionRetry: 'Retry',
  errorNetwork: 'No connection. Check the internet and try again.',
  errorServerUnavailable: 'The server is not responding. Try again in a minute.',
  errorTooManyRequests: 'Too many attempts. Wait a little and try again.',
  errorSomethingWrong: 'Something went wrong. Try again.',
} as const satisfies Record<string, string>;

export type CommonMessageKey = keyof typeof en;

export const commonMessages: Record<AppLocale, Record<CommonMessageKey, string>> = {
  en,
  ru: {
    actionUndo: 'Отменить',
    actionRetry: 'Повторить',
    errorNetwork: 'Нет связи. Проверьте интернет и попробуйте ещё раз.',
    errorServerUnavailable: 'Сервер не отвечает. Попробуйте через минуту.',
    errorTooManyRequests: 'Слишком много попыток. Подождите немного и повторите.',
    errorSomethingWrong: 'Что-то пошло не так. Попробуйте ещё раз.',
  },
  sr: {
    actionUndo: 'Poništi',
    actionRetry: 'Pokušaj ponovo',
    errorNetwork: 'Nema veze. Proverite internet i pokušajte ponovo.',
    errorServerUnavailable: 'Server ne odgovara. Pokušajte za minut.',
    errorTooManyRequests: 'Previše pokušaja. Sačekajte malo i pokušajte ponovo.',
    errorSomethingWrong: 'Nešto nije u redu. Pokušajte ponovo.',
  },
  fr: {
    actionUndo: 'Annuler',
    actionRetry: 'Réessayer',
    errorNetwork: 'Pas de connexion. Vérifiez Internet et réessayez.',
    errorServerUnavailable: 'Le serveur ne répond pas. Réessayez dans une minute.',
    errorTooManyRequests: 'Trop de tentatives. Patientez un peu et réessayez.',
    errorSomethingWrong: 'Un problème est survenu. Réessayez.',
  },
};
